export const APP_VERSION = "appVersion";
